module.exports = __webpack_public_path__ + "img/60.b2f8c30b.png";